import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../src/locales/en.json";
import arr from "../src/locales/arr.json";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      eng: { translation: en },
      arr: { translation: arr }
    },
    lng: "en", // default language
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
